<template>
    <div>
      <Pos_invoices_tax_refund/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_refund from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_refund";
  export default {
    name: "PosInvoicesTaxRefund",
    components: {
      Pos_invoices_tax_refund
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  